import React, { Component } from 'react';
import Modal from 'react-modal';
import { connect } from 'react-redux';
import './index.css';

class Index extends Component {
  state = {
    isOpen: false,
  };

  open = this.open.bind(this);

  close = this.close.bind(this);

  onAfterOpen = this.onAfterOpen.bind(this);

  UNSAFE_componentWillMount() {
    Modal.setAppElement('body');
  }

  componentDidMount() {
    this.props.getOpenFn(this.open);
    if (this.props.getCloseFn) this.props.getCloseFn(this.close)
  }

  onAfterOpen() {
    const { onAfterOpen } = this.props;
    onAfterOpen && onAfterOpen();
  }

  open() {
    this.setState({ isOpen: true });
  }

  close() {
    this.setState({ isOpen: false });
  }

  render() {
    const {
      children, settings, title, fullPage, closeWord, customStyle
    } = this.props;

    const style = fullPage
      ? {
        width: '100%',
        height: '100%',
      }
      : {
        width: '95%',
        maxHeight: '95%',
      };

    const closeStyle = closeWord
      ? {
        position: 'absolute',
        top: '0',
        right: '10px',
        fontSize: '14px',
        color: 'RGB(151, 184, 221)',
      }
      : {
        position: 'absolute',
        top: '0px',
        right: '10px',
        fontSize: '30px',
        color: 'RGB(151, 184, 221)',
      };

    return (
      <Modal
        closeTimeoutMS={300}
        isOpen={this.state.isOpen}
        onRequestClose={this.close}
        onAfterOpen={this.onAfterOpen}
        style={{ content: { ...settings.style.body, ...style, ...customStyle } }}
        appElement={document.querySelector('.main-panel')}
      >
        {title && (
          <h3
            style={{ ...settings.style.title, ...{
              fontSize: '20px',
              margin: '20px 15px 0px',
            }}}
          >
            {title}
          </h3>
        )}
        <div style={{ height: 'calc(100% - 70px)' }}>{children}</div>

        <span className="pointer" color={settings.style.body.color} onClick={this.close} style={closeStyle}>
          {closeWord || <span>&times;</span>}
        </span>
      </Modal>
    );
  }
}

export default connect(({ settings }) => ({
  settings,
}))(Index);
